import { render, staticRenderFns } from "./stationVent.vue?vue&type=template&id=7c452c86&scoped=true"
import script from "./stationVent.vue?vue&type=script&lang=js"
export * from "./stationVent.vue?vue&type=script&lang=js"
import style0 from "./stationVent.vue?vue&type=style&index=0&id=7c452c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c452c86",
  null
  
)

export default component.exports